import backend, {COMMUNICATION_API} from 'utils/backend/server/api_library';

const getSmsSubscription = (userRn) => {
  const url = `${COMMUNICATION_API}/user/${userRn}/sms/subscription`;
  return backend.get(url);
};

const createSmsSubscription = (userRn, phoneNumber) => {
  const url = `${COMMUNICATION_API}/user/${userRn}/sms/subscription`;
  const body = {
    phoneNumber,
  };
  return backend.post(url, body);
};

export default {
  createSmsSubscription,
  getSmsSubscription,
};
